import React from "react";
import { StyleSheet, View } from "react-native";
import { router } from "expo-router";
import { ThemedText } from "@/components/ThemedText";
import { Button } from "@/components/ui/Button";
import { useTheme } from "@/hooks/useTheme";
import { MaterialIcons } from "@expo/vector-icons";

export default function IneligibleScreen() {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <View style={styles.content}>
        <View style={[styles.iconContainer, { backgroundColor: colors.ruby?.background || "#FEE2E2" }]}>
          <MaterialIcons name="block" size={64} color={colors.ruby?.text || "#DC2626"} />
        </View>

        <ThemedText style={[styles.title, { color: colors.text }]}>Unable to Continue</ThemedText>

        <ThemedText style={[styles.description, { color: colors.textSecondary }]}>
          We appreciate your interest in working with RockForce. Unfortunately, we are unable to process your
          application at this time.
        </ThemedText>

        <View style={[styles.requirementsCard, { backgroundColor: colors.card, borderColor: colors.border }]}>
          <ThemedText style={[styles.requirementsTitle, { color: colors.text }]}>Employment Requirements</ThemedText>
          <View style={styles.requirementsList}>
            <View style={styles.requirementItem}>
              <MaterialIcons name="check-circle" size={20} color={colors.emerald?.text || colors.primary} />
              <ThemedText style={[styles.requirementText, { color: colors.textSecondary }]}>
                Must be authorized to work in the United States
              </ThemedText>
            </View>
            <View style={styles.requirementItem}>
              <MaterialIcons name="check-circle" size={20} color={colors.emerald?.text || colors.primary} />
              <ThemedText style={[styles.requirementText, { color: colors.textSecondary }]}>
                Must be at least 18 years of age
              </ThemedText>
            </View>
          </View>
        </View>

        <ThemedText style={[styles.contactText, { color: colors.textSecondary }]}>
          If you believe this is an error or have questions, please contact us at{" "}
          <ThemedText style={{ color: colors.primary }}>careers@nexuspayroll.com</ThemedText>
        </ThemedText>

        <Button
          text="Return Home"
          icon="home"
          iconSize={18}
          iconColor="white"
          onPress={() => router.replace("/")}
          style={[styles.homeButton, { backgroundColor: colors.primary }]}
          textStyle={styles.homeButtonText}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
  },
  content: {
    padding: 24,
    alignItems: "center",
    gap: 20,
  },
  iconContainer: {
    width: 120,
    height: 120,
    borderRadius: 60,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 8,
  },
  title: {
    fontSize: 28,
    fontWeight: "bold",
    textAlign: "center",
  },
  description: {
    fontSize: 16,
    textAlign: "center",
    lineHeight: 24,
  },
  requirementsCard: {
    width: "100%",
    borderRadius: 12,
    borderWidth: 1,
    padding: 20,
    gap: 16,
  },
  requirementsTitle: {
    fontSize: 16,
    fontWeight: "600",
  },
  requirementsList: {
    gap: 12,
  },
  requirementItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  requirementText: {
    fontSize: 14,
    flex: 1,
  },
  contactText: {
    fontSize: 14,
    textAlign: "center",
    lineHeight: 20,
  },
  homeButton: {
    borderRadius: 8,
    minHeight: 52,
    minWidth: 200,
    marginTop: 8,
  },
  homeButtonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "600",
  },
});
